import { DoctorLayout } from "@/components/layout/doctor-layout";
import { EventsList } from "@/components/events/events-list";

export default function DoctorEvents() {
  return (
    <DoctorLayout title="Events">
      <EventsList
        intro="BSR & EULAR congresses, RCP updates, JRCPTB events, rheumatology grand rounds, and more — UK CPD and revalidation-relevant events in one place."
        accentBg="bg-rose-100"
        accentIcon="text-rose-700"
        accentLink="text-rose-600 hover:text-rose-800"
      />
    </DoctorLayout>
  );
}
